import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-modal-confirm-logout',
  templateUrl: './modal-confirm-logout.component.html',
  styleUrls: ['./modal-confirm-logout.component.css'],
})
export class ModalConfirmLogoutComponent {
  onClose: Subject<boolean> = new Subject();

  constructor(private bsModalRef: BsModalRef) {}

  close(logout?: boolean) {
    this.onClose.next(logout ?? false);
    this.onClose.complete();
    this.bsModalRef.hide();
  }

  logout() {
    this.close(true);
  }
}
